import { Routes } from '@angular/router';
import { ClientListComponent } from './pages/client-list.component';
import { ClientManagerComponent } from './pages/client-manager.component';
import { TestUserManagerComponent } from './pages/test-user-manager.component';
import { CustomerManagerComponent } from './pages/customer-manager.component';
import { ClientSettingsComponent } from './pages/client-manager/client-settings.component';
import { NewClientTemplateComponent } from './pages/client-manager/new-client-template.component';
import { NewClientComponent } from './pages/client-manager/new-client.component';
import { EditRoleComponent } from './pages/client-manager/edit-role.component';
import { AddRoleComponent } from './pages/client-manager/add-role.component';
import { EditTokenMapperComponent } from './pages/client-manager/edit-token-mapper.component';
import { AddTokenMapperComponent } from './pages/client-manager/add-token-mapper.component';
import { NewCustomerAccountComponent } from './pages/customer-manager/new-customer-account.component';
import { EditCustomerAccountComponent } from './pages/customer-manager/edit-customer-account.component';
import { ExportCustomerAccountsComponent } from './pages/customer-manager/export-customer-accounts.component';
import { NewTestUserComponent } from './pages/test-user-manager/new-test-user.component';
import { EditTestUserComponent } from './pages/test-user-manager/edit-test-user.component';
import { DashboardComponent } from './pages/dashboard.component';
import { OverviewComponent } from './pages/overview.component';
import { SecurityGuardComponent } from './pages/security-guard.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  // TODO: No longer used, but we keep it for now so the translations do not get deleted
  {
    path: 'overview',
    component: OverviewComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'client-list',
    component: ClientListComponent,
  },
  {
    path: 'guard',
    component: SecurityGuardComponent,
  },
  {
    path: 'clients',
    children: [
      {
        path: '',
        component: ClientManagerComponent,
      },
      {
        path: 'template',
        component: NewClientTemplateComponent,
      },
      {
        path: 'new',
        component: NewClientComponent,
      },
      {
        path: ':id',
        children: [
          {
            path: '',
            component: ClientSettingsComponent,
          },
          {
            path: 'roles/new',
            component: AddRoleComponent,
          },
          {
            path: 'roles/:roleId',
            component: EditRoleComponent,
          },
          {
            path: 'mappers/new',
            component: AddTokenMapperComponent,
          },
          {
            path: 'mappers/:mapperId',
            component: EditTokenMapperComponent,
          },
          {
            path: ':tab',
            component: ClientSettingsComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'test-users',
    children: [
      {
        path: '',
        component: TestUserManagerComponent,
      },
      {
        path: 'new',
        component: NewTestUserComponent,
      },
      {
        path: ':userId',
        children: [
          {
            path: '',
            component: EditTestUserComponent,
          },
          {
            path: ':tab',
            component: EditTestUserComponent,
          },
        ],

      },
    ],
  },
  {
    path: 'customers',
    children: [
      {
        path: '',
        component: CustomerManagerComponent,
      },
      {
        path: 'new',
        component: NewCustomerAccountComponent,
      },
      {
        path: 'export',
        component: ExportCustomerAccountsComponent,
      },
      {
        path: ':userId',
        children: [
          {
            path: '',
            component: EditCustomerAccountComponent,
          },
          {
            path: ':tab',
            component: EditCustomerAccountComponent,
          },
        ],
      },
    ],
  },
];
